import(/* webpackMode: "eager" */ "/vercel/path0/app/services/IA/page.tsx");
